// extracted by mini-css-extract-plugin
module.exports = {"fareType_economy":"fareType_economy-1z7MW","active":"active-3d-vc","fareType_business":"fareType_business-GeWJ1"};